export default __webpack_public_path__ + "static/media/Confectionery5.250440b4.png";